export default __webpack_public_path__ + "static/media/pauseIcon.98d97aee.svg";